<!--Login Page Starts-->
<section id="login">
    <div class="container-fluid">
        <div class="row full-height-vh">
            <div class="col-12 d-flex align-items-center justify-content-center">
                <div class="card gradient-blueberry text-center width-400">
                    <!-- <div class="card-img overlap">
                        <img alt="element 06" class="mb-1" src="assets/img/portrait/avatars/avatar-08.png" width="190">
                    </div> -->
                    <div class="card-body">
                        <div class="card-block">
                            <h2 class="white mt-2 mb-2">Login</h2>
                            <form novalidate="" (ngSubmit)="onSubmit()" #form="ngForm">
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <input type="email" class="form-control" name="email" placeholder="{{'email_username' | translate}}" ngModel #email="ngModel" minlength="3" required email>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="col-md-12">
                                        <input type="password" class="form-control" name="password" placeholder="{{'password' | translate}}" #password="ngModel" ngModel minlength="6" maxlength="50" required>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0 ml-3">
                                                <!-- <input type="checkbox" class="custom-control-input" checked id="rememberme">
                                                <label class="custom-control-label float-left white" for="rememberme">Remember Me</label> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="col-md-12">
                                        <button type="submit" class="btn btn-indigo btn-block btn-raised" [disabled]="form.invalid" [ladda]="loading">{{'login' | translate}}</button>
                                        <!-- <button type="button" class="btn btn-indigo btn-lighten-5 btn-block">Cancel</button> -->
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="float-left"><a (click)="onForgotPassword()" class="white">{{'forgot_password' | translate}}</a></div>
                        <div class="float-right"><a (click)="onRegister()" class="white">{{'create_account' | translate}} ></a></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Login Page Ends-->


// WEBPACK FOOTER //
// ./src/app/login/login.component.html